module.exports = __webpack_public_path__ + "static/media/gcdef_114.d42eda57.ico";